"use strict";

require("../../style/index.less");

require("./index.less");

require("../../button/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/modal/style/index.js
// module id = 42
// module chunks = 1